export const customTaxPayoutDetailsInfo: string = $localize`* according to Polish regulations, in the case of winnings above PLN 2279.99 a 10% tax on winnings will be charged`;
